const axios = require('axios');
const firebase = require("firebase")
const config = require('./application.properties')
const {saveAppSettings} = require("./FirebaseUtil");
const {apps} = require("firebase");
const {useContext} = require("react");
const {AuthContext} = require("../authentication/Auth");
const axiosInstance =  require("../axios/axios").default;

module.exports.import = function (list,t) {
    console.log("Inside import APs & Sites")

    return new Promise((resolve) => {
        let importAPs = firebase.functions().httpsCallable(config.IMPORT_AP_METHOD)

        importAPs(list).then(res => {
            console.log(res.data)
            return resolve({
                status: res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("Import Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : t('messages.error.err36') //'Unable to process the CSV.'
            })
        })
    })
}

module.exports.createUser = function (user, t) {
    console.log("Inside createUser")

    return new Promise((resolve) => {
        axiosInstance.post(config.CREATE_USER_METHOD[user.role],{
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            authType: user.authType,
            password: user.password,
            language: user.language,
            siteName: user.siteName,
            displaySiteName: user.displaySiteName,
            disabled: user.disabled,
        }).then(res => {
            console.log(res.data)
            return resolve({
                statusCode: res.data.statusCode,
                status: res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("Error",error);
            return resolve({
                status: error && error?.response?.data && error?.response?.data.success ? error?.response?.data?.success : false,
                msg: error?.response?.data?.msg  ?? error?.response?.data?.message ?? error?.message ?? t('messages.error.err37') //'Unable to create the user profile.'
            })
        })
    })
}

/**
 * Updates user's information (firstName, lastName, language, siteName, displaySiteName)
 */
module.exports.updateUser = function (userData, t) {
    console.log("Inside updateUser with data:", userData);
    
    // Prepare the payload based on user data
    const payload = {
        email: userData.email,
        authType: userData.authType,
        firstName: userData.firstName,
        lastName: userData.lastName,
        language: userData.language,
        siteName: userData.siteName,
        displaySiteName: userData.displaySiteName
    };

    return new Promise((resolve) => {
        axiosInstance.post(config.UPDATE_USER, payload)
            .then(res => {
                console.log('Update response:', res);
                return resolve({
                    status: res.data.success,
                    msg: res.data.msg
                });
            })
            .catch(error => {
                console.error("Update Error:", error);
                return resolve({
                    status: error?.response?.data?.success || false,
                    msg: error?.response?.data?.msg || error?.message || t('messages.error.err55')
                });
            });
    });
};

/**
 * Updates only the status of a user
 */
module.exports.updateUserStatus = function (email, authType, disabled, t) {
    console.log(`Updating user status: ${email} to disabled: ${disabled}`);
    
    const payload = {
        email,
        authType,
        disabled
    };

    return new Promise((resolve) => {
        axiosInstance.post(config.UPDATE_USER_STATUS, payload)
            .then(res => {
                console.log('Status update response:', res);
                return resolve({
                    status: res.data.success,
                    msg: res.data.msg
                });
            })
            .catch(error => {
                console.error("Status Update Error:", error);
                return resolve({
                    status: error?.response?.data?.success || false,
                    msg: error?.response?.data?.msg || error?.message || t('messages.error.err55')
                });
            });
    });
};

module.exports.importDevices = function (list,t) {
    console.log("Inside importDevices")

    return new Promise((resolve) => {
        let importDevices = firebase.functions().httpsCallable(config.IMPORT_DEVICES_METHOD)

        importDevices(list).then(res => {
            console.log(res.data)
            return resolve({
                status: res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("importDevices Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message :  t('messages.error.err36') //'Unable to process the CSV.'
            })
        })
    })
}

module.exports.saveAppSettings = function (data,t) {
    console.log("Inside saveAppSettings")
    return new Promise((resolve,reject) => {
        axiosInstance.post(config.SAVE_APP_SETTINGS,data).then(res => {
            return resolve({
                status: res.data && res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("saveSSOSettings Error: " + JSON.stringify(error))
            return reject({
                status: false,
                msg: error ? error.message : 'Unable to save the SSO settings.'
            })
        })
    })
}

module.exports.mapdtrkToSSORoles = function (data) {
    console.log("Inside mapdtrkToSSORoles",data)
    return new Promise((resolve) => {

        axiosInstance.post(config.MAP_DTRK_TO_SSO_ROLES,data).then(res => {
            return resolve({
                status: res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("mapdtrkToSSORoles Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : 'Unable to save the SSO settings.'
            })
        })
    })
}

module.exports.testSSOSettings = function (data) {
    console.log("Inside testSSOSettings",data)

    return new Promise((resolve) => {
        axiosInstance.post(config.TEST_SSO_SETTINGS,data).then(res => {
            return resolve({
                status: res.data.status,
                msg: res.data.msg
            })

        }).catch(error => {
            return resolve({
                status: 401,
                msg: error ? error.message:''
            })
        })
    })
}

module.exports.saveAppConfiguration = function (data,t) {
    console.log("Inside saveAppConfiguration")
    return new Promise((resolve) => {
        axiosInstance.post(config.SAVE_APP_CONFIGURATION,data).then(res => {
            return resolve({
                status: res.data && res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("saveAppConfiguration Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : t('messages.error.err10') //'Unable to save the app settings.'
            })
        })
    })
}

module.exports.recomDecom = function (data,t) {


    console.log("Inside recomDecom",data)
    return new Promise((resolve) => {
        axiosInstance.post(config.RECOM_DECOM,data).then(res => {
            console.log(res,'resres')
            return resolve({
                status: res.data.status == 'OK',
                msg: res.data.details
            })
        }).catch(error => {
            console.log("error ",error);
            if(error.response.data.details){
               error.message = error.response.data.details;
            }
            return resolve({
                status: false,
                msg: error.message ? error.message :t('messages.error.err48')
            })
        })
    })










    // return new Promise((resolve) => {
    //     console.log(config.RECOM_DECOM,'config.RECOM_DECOM')
    //     let saveRecomDecomCall = firebase.functions().httpsCallable(config.RECOM_DECOM)

    //     saveRecomDecomCall(data).then(res => {
    //     console.log('res :', res);
    //         return resolve({
    //             status: res.data.status ? res.data.status === 'OK' ?  true : false : false,
    //             msg: res.data.details
    //         })

    //     }).catch(error => {
    //         console.log("recomDecom Error: " + JSON.stringify(error))
    //         return resolve({
    //             status: false,
    //             msg: error ? error.message : t('messages.error.err48') //'Unable to save the app settings.'
    //         })
    //     })
    // })
}

module.exports.getAppSettings = function (t) {
    return new Promise((resolve) => {
        console.log("Inside getAppSettings")

        axiosInstance.get(config.GET_APP_SETTINGS).then(res => {
            return resolve(res.data.data)
        }).catch(error => {
            console.log("getAppSettings Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : t('messages.appSettings.msg1')
            })
        })
    })
}

module.exports.saveSSOSettings = function (data) {
    console.log("Inside saveSSOSettings")
     data.clientAuthType = parseInt(data.clientAuthType);
     console.log(data);
   
    return new Promise((resolve) => {
        axiosInstance.post(config.SAVE_SSO_SETTINGS,data).then(res => {
            return resolve({
                status: res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("saveSSOSettings Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : 'Unable to save the SSO settings.'
            })
        })
    })
}

module.exports.mapdtrkToSSORoles = function (data) {
    console.log("Inside mapdtrkToSSORoles",data)
    return new Promise((resolve) => {

        axiosInstance.post(config.MAP_DTRK_TO_SSO_ROLES,data).then(res => {
            return resolve({
                status: res.data.success ? res.data.success : false,
                msg: res.data.msg
            })

        }).catch(error => {
            console.log("mapdtrkToSSORoles Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : 'Unable to save the SSO settings.'
            })
        })
    })
}

module.exports.testSSOSettings = function (data) {
    console.log("Inside testSSOSettings",data)

    return new Promise((resolve) => {
        axiosInstance.post(config.TEST_SSO_SETTINGS,data).then(res => {
            return resolve({
                status: res.data.status,
                msg: res.data.msg
            })

        }).catch(error => {
            return resolve({
                status: 401,
                msg: error ? error.message:''
            })
        })
    })
}

module.exports.getSSOSettings = function (authSSOProvider) {
    console.log("Inside getSSOSettings")
    let ssoParams = {auth:true}
    if(authSSOProvider){
        ssoParams.ssoProvider = authSSOProvider
    }
    return new Promise((resolve) => {
        axiosInstance.get(config.GET_SSO_SETTINGS,{params: ssoParams}).then(res => {
            let settings = res.data.data;
            settings.status = true;
            console.log(settings);
            return resolve(settings)
        }).catch(error => {
            console.log("getSSOSettings Error: " + JSON.stringify(error))
            return resolve({
                status: false,
                msg: error ? error.message : 'Unable to get the SSO settings.'
            })
        })
    })
}

module.exports.getServerVersion = function () {
    console.log("Inside getServerVersion")
    return new Promise(resolve => {
        axiosInstance.get(config.GET_SERVER_VERSION).then(res => {
            return resolve({
                status: 200,
                msg: res.data
            })
        }).catch(error => {
            console.log("saveAppSettings Error: " + JSON.stringify(error))
            return resolve({
                status: 500,
                msg: error
            })
        })

    })
}

module.exports.getFirebaseTokenFromSSO = function (authCode,codeVerifier) {
    console.log("Inside getFirebaseTokenFromSSO")
    return new Promise((resolve, reject) => {
        let data = {
            code: authCode,
            codeVerifier:codeVerifier,
            auth:false
        }
        console.log("data : ", JSON.stringify(data))
        axiosInstance.post(config.GET_FIREASE_TOKEN_FROM_SSO,data).then(res => {
            return resolve(res.data);
        }).catch(error => {
            console.log("getFirebaseTokenFromSSO Error:", error.response.data);
            return reject(error.response.data);
            // console.log("getFirebaseTokenFromSSO Error: " + JSON.stringify(error))
            // return reject(error);
        })
    })
}

module.exports.getSSOUserInfo = function () {
    console.log("Inside getSSOUserInfo")
    return new Promise((resolve, reject) => {
        axiosInstance.get(config.GET_SSO_USER_INFO).then(res => {
            return resolve(res.data)
        }).catch(error => {
            return reject(error)
        })
    })
}

module.exports.deleteUser = function (data, t) {
    console.log("Inside deleteUser")
    return new Promise((resolve) => {
        axiosInstance.post(config.DELETE_USER,data).then(res => {
            return resolve({
                status: res.data.success,
                msg: res.data.msg
            })
        }).catch(error => {
            return resolve({
                status: error.response.data && error.response.data.success ? error.response.data.success : false,
                msg: error.response.data && error.response.data.msg  ? error.response.data.msg : t('messages.error.err13')
            })
        })

    })
}


module.exports.resetPassword = function (data,t) {
    console.log("Inside resetPassword",data)
    data["auth"] = false;
    return new Promise((resolve) => {
        axiosInstance.post(config.RESET_PASSWORD,data).then(res => {
            return resolve({
                status: res.data.success,
                msg: res.data.msg
            })
        }).catch(error => {
            console.log("error ",error);
            return resolve({
                status: error.response.data && error.response.data.success ? error.response.data.success : false,
                msg: error.response.data && error.response.data.msg  ? error.response.data.msg : t('messages.error.err13')
            })
        })
    })
}

module.exports.revokeTokenAccess = function (t) {
    console.log("Inside revokeTokenAccess")
    return new Promise((resolve) => {
        axiosInstance.post(config.REVOKE_TOKEN_ACCESS,{}).then(res => {
            return resolve({
                status: res.data.success,
                msg: res.data.msg
            })
        }).catch(error => {
            console.log("error ",error);
            return resolve({
                status: false,
                msg: error.message ? error.message :t('messages.error.err35') //'Unable to revoke token.'
            })
        })
    })
}

module.exports.ssoSessionLogout = function () {
    console.log("Inside ssoSessionLogout")

    return new Promise((resolve, reject) => {
        axiosInstance.post(config.SSO_SESSION_LOGOUT,{}).then(res => {
            return resolve({
                status: res.data.success,
                msg: res.data.msg
            })
        }).catch(error => {
            console.error(JSON.stringify(error));
            return reject(error);
        })
    })
}

module.exports.revokeTokenWithSSOServer = function () {
    console.log("Inside revokeTokenWithSSOServer")

    return new Promise((resolve, reject) => {
        axiosInstance.post(config.REVOKE_TOKEN_WITH_SSO_SERVER,{}).then(res => {
            return resolve({
                status: res.data.success,
                msg: res.data.msg
            })
        }).catch(error => {
            console.error(JSON.stringify(error));
            return reject(error);
        })
    })
}

module.exports.getCheckoutLogData = function (params) {
    console.log("Inside revokeTokenAccess")

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_CHECKOUT_LOG_DATA,params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getCheckoutLogs = function (params) {
    console.log("Inside revokeTokenAccess")

    return new Promise((resolve) => {
        let getCheckoutLogs = firebase.functions().httpsCallable('getCheckoutLogs')
        getCheckoutLogs(params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getDeviceCountAxios = function (params) {
    console.log("Inside getDeviceCountAxios", params)
    const queryParams = new URLSearchParams(params).toString();
    const url = config.GET_DEVICE_COUNT+"?"+queryParams;
    return new Promise((resolve) => {
        axiosInstance.get(url,{}).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            if(error?.response?.status === 401){
                alert("Internal Server Error");
                /**
                 * added timeout of 1 second because  (app.auth().onAuthStateChanged) auth state change take
                 * some time to save auth data
                */
                setTimeout(()=>{
                    this.revokeTokenAccess()
                    .then(()=>{
                        return firebase.auth().signOut()
                    }) 
                },1000)
                 
            }
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getDeviceCountByKiosksAxios = function (params) {
    console.log("Inside getDeviceCountByKiosksAxios", params)
    const url = config.GET_DEVICE_COUNT_BY_KIOSKS;
    return new Promise((resolve) => {
        axiosInstance.post(url, params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            if(error?.response?.status === 401){
                alert("Internal Server Error");
                /**
                 * added timeout of 1 second because  (app.auth().onAuthStateChanged) auth state change take
                 * some time to save auth data
                */
                setTimeout(()=>{
                    this.revokeTokenAccess()
                    .then(()=>{
                        return firebase.auth().signOut()
                    }) 
                },1000)
                 
            }
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getDeviceListByKiosksAxios = function (params) {
    const url = config.GET_DEVICE_LIST_BY_KIOSKS;
    return new Promise((resolve) => {
        axiosInstance.post(url, params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            if(error?.response?.status === 401){
                alert("Internal Server Error");
                /**
                 * added timeout of 1 second because  (app.auth().onAuthStateChanged) auth state change take
                 * some time to save auth data
                */
                setTimeout(()=>{
                    this.revokeTokenAccess()
                    .then(()=>{
                        return firebase.auth().signOut()
                    }) 
                },1000)
                 
            }
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getDeviceCount = function (params) {
    console.log("Inside getDeviceCount")

    return new Promise((resolve) => {
        let getDeviceCount = firebase.functions().httpsCallable('getDeviceCount')
        getDeviceCount(params).then(res => {
            console.log(res.data);
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            console.log(error.message);
            
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getDeviceList = function (params) {
    return new Promise((resolve) => {
        let getDeviceList = firebase.functions().httpsCallable('getDeviceList')
        getDeviceList(params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {            
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get device List."
            })
        })
    })
}

module.exports.updateDeviceStatus = function (params) {
    const url = config.UPDATE_DEVICE;
    return new Promise((resolve) => {
        console.log("UpdateDevice params ", params);
        axiosInstance.post(url, params).then(res => {
            return resolve({
                status: res.data,
                data: res.data
            })
        }).catch(error => {
            if(error?.response?.status === 401){
                alert("Internal Server Error");
                /**
                 * added timeout of 1 second because  (app.auth().onAuthStateChanged) auth state change take
                 * some time to save auth data
                */
                setTimeout(()=>{
                    this.revokeTokenAccess()
                    .then(()=>{
                        return firebase.auth().signOut()
                    }) 
                },1000)
                 
            }
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getDeviceUtilizationData = function (params) {
    console.log("Inside revokeTokenAccess")

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_DEVICE_UTILIZATION_DATA,params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get device utilization data."
            })
        })
    })
}

module.exports.getEventCounts = function (params) {
    console.log("Inside getEventCounts")

    return new Promise((resolve) => {
        let getEventCounts = firebase.functions().httpsCallable('getEventCounts')
        axiosInstance.post(config.GET_EVENT_COUNTS,params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get event counts."
            })
        })
    })
}

module.exports.getDeviceCheckoutCountData = function (params) {
    console.log("Inside getDeviceCheckoutCountData")

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_DEVICE_CHECKOUT_COUNT_DATA,params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get event counts."
            })
        })
    })
}

module.exports.getSiteEventData = function (params) {
    console.log("Inside getSiteEventData")

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_SITE_EVENT_DATA,params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get site event data."
            })
        })
    })
}

module.exports.exportCsvDataToGcsBucketEventDetail = function (data) {
    console.log("Inside exportCsvDataToGcsBucket")
    // let startDate = new Date(data.startDate).toJSON().slice(0, 10)
    // let endDate = new Date(data.endDate).toJSON().slice(0, 10)
    //console.log("StartDate:", startDate + " | EndDate:", endDate)
    console.log("StartDate:", data.startDate + " | EndDate:", data.endDate)
    return new Promise((resolve => {
        axios.post(data.endPoint, {
            'startDate': data.startDate,
            'endDate': data.endDate,
            'siteName': data.siteName,
            'category': data.category,
            'subCategory': data.subCategory,
            'deviceStateUpdatedBy': data.deviceStateUpdatedBy,
            'siteMovementCategory':data.siteMovementCategory
        }, {
            headers: {
                'authorization': `Bearer ${data.token}`,
            }
        })
            .then(function (response) {
                //console.log("Response Body: ", response.data);
                //console.log("Response: ", response);
                return resolve({
                    statusCode: response.status,
                    status: response.data.status,
                    data: response.data.files_path
                })
            })
            .catch(function (error) {
                console.log("Response Body [Error]: ", error)
                return resolve({
                    statusCode: error.status,
                    status: false,
                    msg: error.message ? error.message : "Unable to export CSV Data to GCS Bucket and get the file path"
                })
            });
    }))

}

module.exports.exportCsvDataToGcsBucket = function (data) {
    console.log("Inside exportCsvDataToGcsBucket")
    let startDate = new Date(data.startDate).toJSON().slice(0, 10)
    let endDate = new Date(data.endDate).toJSON().slice(0, 10)
    console.log("StartDate:", startDate + " | EndDate:", endDate)
    return new Promise((resolve => {
        axios.post(data.endPoint, {
            'startDate': startDate,
            'endDate': endDate,
            'site': data.site
        }, {
            headers: {
                'authorization': `Bearer ${data.token}`,
            }
        })
            .then(function (response) {
                //console.log("Response Body: ", response.data);
                //console.log("Response: ", response);
                return resolve({
                    statusCode: response.status,
                    status: response.data.status,
                    data: response.data.files_path
                })
            })
            .catch(function (error) {
                console.log("Response Body [Error]: ", error)
                return resolve({
                    statusCode: error.status,
                    status: false,
                    msg: error.message ? error.message : "Unable to export CSV Data to GCS Bucket and get the file path"
                })
            });
    }))

}

module.exports.uploadZipFileToGcsBucket = function (data) {
    console.log("Inside uploadZipFileToGcsBucket")

    return new Promise((resolve => {
        axios.post(data.endPoint, {
            "file_path": data.file_path
        }, {
            headers: {
                'authorization': `Bearer ${data.token}`,
            }
        })
            .then(function (response) {
                //console.log("Response Body: ", response.data);
                //console.log("Response: ", response);
                return resolve({
                    statusCode: response.status,
                    status: response.data.status,
                    data: response.data.filePath
                })
            })
            .catch(function (error) {
                console.log("Response Body [Error]: ", error)
                return resolve({
                    statusCode: error.statusCode,
                    status: false,
                    msg: error.message ? error.message : "Unable to upload zip file to GCS Bucket and get the file path"
                })
            });
    }))
}

module.exports.getSnapshotData = function (params) {
    console.log("Inside getSnapshotData")

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_SNAPPSHOT_DATA,params).then(res => {
            return resolve({
                status: res.data.success,
                data: res.data
            })
        }).catch(error => {
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to revoke token."
            })
        })
    })
}


module.exports.exportConfiguration = function (data,t) {
    console.log(data,'data')
    console.log("Inside exportConfiguration")

    return new Promise((resolve) => {
        axiosInstance.post(config.EXPORTCSV,data).then(res => {
            console.log(res,'res in export csv')
            console.log(res.data,'res.data')
            console.log(res.data.success,'res.data.success')
            return resolve({
                status: res.data.success === true,
                msg: res.data.msg
            })
        }).catch(error => {
            console.log("error ",error);
            return resolve({
                status: false,
                msg: error.message ? error.message :'messages.error.err48'
            })
        })
    })
}

module.exports.savePassCodes = function (data) {
    try{
        return axiosInstance.post("passCodes",data)
    }catch(error) {
        throw new Error(error);
    }
}

module.exports.getPassCodes = function () {
    try{
        return axiosInstance.get('passCodes')
    }catch(error) {
        throw new Error(error);
    }
}

module.exports.ssoRefreshToken = function (){
    try{
        return axiosInstance.post('ssoRefreshTokenSSO',{})
    }catch(error) {
        throw new Error(error);
    }
}

module.exports.getSiteEvents = function (data){
    try{
        return axiosInstance.post('siteEvents',data)
    }catch(error) {
        throw new Error(error);
    }
}

module.exports.sendIndividualSiteEvents = function (data){
    try{
        return axiosInstance.post('getEventsByCategory',data);
    }catch(error) {
        throw new Error(error);
    }
}

module.exports.generateXmlAndBarcodeZip = function (){
    return new Promise((resolve,reject) => {
        return axiosInstance.get('generateXmlAndBarcodeZip').then(res=>{
            console.log('generateXmlAndBarcodeZip  ',res.data)
            return resolve(res.data)
        }).catch(err=>{
            console.log('generateXmlAndBarcodeZip: err ',err)
            return reject(err)
        });
    })
}

module.exports.getSiteMovementDevices = function (data){
    try{
        return axiosInstance.post('getEventsByCategory/deviceSiteMovement',data)
    }catch(error) {
        throw new Error(error);
    }
}


// Fetch Device Count Function
module.exports.fetchDevicesCount = function (params) {
    console.log("Inside fetchDevicesCount");

    return new Promise((resolve) => {
        axiosInstance.post(config.FETCH_DEVICE_COUNT,  params )
            .then(res => {
                return resolve({
                    status: true,
                    data: res.data
                });
            })
            .catch(error => {
                return resolve({
                    status: false,
                    msg: error.message ? error.message : "Unable to fetch device count."
                });
            });
    });
};

// Get Kiosk Devices Function
module.exports.getKioskDevices = function (params) {
    console.log("Inside getKioskDevices");

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_KIOSK_DEVICES, params)
            .then(res => {
                return resolve({
                    status: true,
                    data: res.data
                });
            })
            .catch(error => {
                return resolve({
                    status: false,
                    msg: error.message ? error.message : "Unable to fetch kiosk devices."
                });
            });
    });
};

// Example for GET_KIOSK_NAMES usage
module.exports.getKioskNames = function (params) {
    console.log("Inside getKioskNames");

    return new Promise((resolve) => {
        axiosInstance.post(config.GET_KIOSK_NAMES, params)
            .then(res => {
                return resolve({
                    status: true,
                    data: res.data
                });
            })
            .catch(error => {
                return resolve({
                    status: false,
                    msg: error.message ? error.message : "Unable to fetch kiosk names."
                });
            });
    });
};


module.exports.getIsDGAMLicensed = function () {
    console.log("Inside getIsDGAMLicensed");

    return new Promise((resolve, reject) => {
        axiosInstance.get(config.GET_IS_DGAM_LICENSED)
            .then(res => {
                return resolve(res.data);
            })
            .catch(err => {
                console.log('getIsDGAMLicensed: Error ', err)
                return reject(err)
            });
    });
};
module.exports.setSisenseDataSecurityRules = function (params) {
    const url = config.SET_SISENSE_DATA_SECURITY_RULES;
    return new Promise((resolve) => {
        axiosInstance.get(url, {params}).then(res => {
            return resolve({
                status: res.data,
                data: res.data
            })
        }).catch(error => {
            if(error?.response?.status === 401){
                alert("Internal Server Error");
                /**
                 * added timeout of 1 second because  (app.auth().onAuthStateChanged) auth state change take
                 * some time to save auth data
                */
                setTimeout(()=>{
                    this.revokeTokenAccess()
                    .then(()=>{
                        return firebase.auth().signOut()
                    }) 
                },1000)
                 
            }
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}

module.exports.getSisenseUrl = function () {
    return new Promise((resolve, reject) => {
        axiosInstance.get(config.GET_SISENSE_URL)
            .then(res => {
                return resolve(res.data);
            })
            .catch(err => {
                console.log('Unable to get sisense url ', err)
                return reject(err)
            });
    });
}

module.exports.silentLoginInSisense = function (params) {
    const url = config.SILENT_SISENSE_LOGIN;
    return new Promise((resolve) => {
        axiosInstance.get(url).then(res => {
            return resolve({
                status: res.data,
                data: res.data
            })
        }).catch(error => {
            if(error?.response?.status === 401){
                alert("Internal Server Error");
                /**
                 * added timeout of 1 second because  (app.auth().onAuthStateChanged) auth state change take
                 * some time to save auth data
                */
                setTimeout(()=>{
                    this.revokeTokenAccess()
                    .then(()=>{
                        return firebase.auth().signOut()
                    }) 
                },1000)
                 
            }
            return resolve({
                status: false,
                msg: error.message ? error.message : "Unable to get checkout logs."
            })
        })
    })
}
